import { getCellIds, getCellNameById } from "../helpers/main";
import { IAction, IActionConfig, IFilterRules } from "../types";
import locale from "../locales/en";

export class Filter implements IAction {
	public config: IActionConfig;
	private _prev: { cell: string; rules: IFilterRules[] };
	constructor(config: IActionConfig) {
		this.config = config;
	}

	do() {
		const { cell: initCell, page, val, grid, spreadsheet } = this.config;
		this._prev = { ...page.getMeta().filter };
		let cell = initCell;
		if (!val) {
			page.setMeta({ filter: null });
			if (page === (spreadsheet as any)._activePage) {
				(spreadsheet as any)._filterForm.applyFilter(page);
			}
			return;
		}
		let cellIds = getCellIds(cell, grid);
		if (!cellIds.end) {
			const [rows, cols] = page.getSize();
			cell = `${getCellNameById(grid, 1, 1)}:${getCellNameById(grid, rows, cols)}`;
			cellIds = getCellIds(cell, grid);
			this.config.cell = cell;
		}
		if (!(spreadsheet as any)._spanControl.checkBeforeAction(this.config.cell, page, locale.filter))
			return;
		const { start, end } = cellIds;
		const colsSelected = end.col - start.col;
		// add empty filters
		while (val.length < colsSelected + 1) {
			val.push({});
		}
		page?.setMeta({ filter: { cell, rules: val } });
		if (page === (spreadsheet as any)._activePage) {
			(spreadsheet as any)._filterForm.applyFilter(page);
		}
	}

	undo() {
		const { cell, val } = this.config;
		this.config.val = this._prev?.rules;
		this.config.cell = this._prev?.cell;
		this.do();
		this.config.cell = cell;
		this.config.val = val;
	}
}
